export default __webpack_public_path__ + "static/media/updateplan.c7241ea9.svg";